import GeneralFactory from 'coreClasses/GeneralFactory';
import AbstractSearchProvider from './providers/AbstractSearchProvider';
import SFCCSearch from './providers/sfcc/SFCCSearch';
import AlgoliaSearchProvider from './providers/algolia/AlgoliaSearch';
import {ESearchProvider, ESearchType} from './ISearch';

/**
 * Represents SearchProvidersFactory
 */
class SearchProvidersFactory extends GeneralFactory {
	/**
	 * Creates search provider
	 * @param {string} providerName - provider name
	 * @param {string} key - search instance key
	 * @param {string} cacheKey - search instance cache key ( used in redux and class cache )
	 * @param {ESearchProvider} searchType - searchType
	 * @returns {AbstractSearchProvider} - search provider
	 */
	create(providerName: ESearchProvider, key: string, cacheKey: string, searchType: ESearchType): AbstractSearchProvider | null {
		switch (providerName) {
			case ESearchProvider.SFCC:
				return new SFCCSearch(this.managerRepository, key, cacheKey, searchType);
			case ESearchProvider.ALGOLIA:
				return new AlgoliaSearchProvider(this.managerRepository, key, cacheKey, searchType);
			default:
				return new SFCCSearch(this.managerRepository, key, cacheKey, searchType);
		}
	}
}

export default SearchProvidersFactory;
